/* eslint-disable newline-before-return */
import { FC, useEffect, useState } from 'react';
import { ListSentencesQuery } from 'API';
import { Auth } from 'aws-amplify';

import {
  Button,
  Checkbox,
  Dimmer,
  Header,
  Icon,
  Loader,
  Message,
} from 'semantic-ui-react';
import useSentence from 'hooks/Sentence';

const CustomButton = (props: {
  content: string;
  color: string;
  onClick: () => void;
}) => {
  return (
    <>
      <div
        onClick={props.onClick}
        style={{
          display: 'table',
          fontSize: '16px',
          border: `2px solid ${props.color}`,
          borderRadius: '8px',
          height: '50px',
          width: '100%',
          textAlign: 'center',
        }}
      >
        <p style={{ display: 'table-cell', verticalAlign: 'middle' }}>
          {props.content}
        </p>
      </div>
    </>
  );
};

const Component: FC = () => {
  const [show, setShow] = useState(false);
  const [isChecked, setIsCheked] = useState(false);
  const [items, setItems] = useState<
    ListSentencesQuery['listSentences']['items']
  >([]);
  const [checkedItems, setCheckedItems] = useState<
    ListSentencesQuery['listSentences']['items']
  >([]);
  const [current, setCurrent] =
    useState<ListSentencesQuery['listSentences']['items'][0]>();
  const [index, setIndex] = useState<number>(0);

  const next = () => {
    if (isChecked && checkedItems.length - 1 === index) return;
    if (isChecked && checkedItems.length === 0) return;
    if (!isChecked && items.length - 1 === index) return;
    if (!isChecked && items.length === 0) return;
    const next = index + 1;
    setIndex(next);
    setCurrent(isChecked ? checkedItems[next] : items[next]);
  };

  const prev = () => {
    if (index === 0) return;
    const next = index - 1;
    setIndex(next);
    setCurrent(items[next]);
  };

  const { isLoading, fetch, update } = useSentence({
    needToFetch: false,
  });

  useEffect(() => {
    fetch().then((result) => {
      if (result === undefined) {
        setItems([]);
        return;
      }
      setItems(result);
      setCheckedItems(result.filter((v) => v.checked === 1));
      setIndex(0);
      if (result.length > 0) {
        setCurrent(result[0]);
      }
    });
  }, []);
  return (
    <>
      {isLoading && (
        <Dimmer active inverted>
          <Loader>Loading...</Loader>
        </Dimmer>
      )}
      <Header as="h3" dividing>
        <div
          style={{
            width: '100%',
            textAlign: 'right',
            padding: '15px 10px 10px 10px',
          }}
        >
          <Button
            color="green"
            onClick={async () => {
              const result = await fetch();
              setItems(result);
              setCheckedItems(result.filter((v) => v.checked === 1));
              setIndex(0);
              setIsCheked(!isChecked);
            }}
          >
            {isChecked ? 'Show All' : 'Filter'}
          </Button>
          <Button
            color="orange"
            onClick={async () => {
              fetch().then((result) => {
                setItems(result);
                setCheckedItems(result.filter((v) => v.checked === 1));
                setIndex(0);
                if (result.length > 0) {
                  setCurrent(result[0]);
                }
              });
            }}
          >
            {' '}
            Reload
          </Button>
          <Button
            color="orange"
            onClick={async () => {
              await Auth.signOut();
              location.href = '/';
            }}
          >
            {' '}
            Sign Out
          </Button>
        </div>
      </Header>
      <div style={{ minHeight: '500px' }}>
        <div style={{ textAlign: 'center', fontSize: '16px' }}>
          {isChecked
            ? `${index + 1} / ${checkedItems.length}`
            : `${index + 1} / ${items.length}`}
        </div>
        <div style={{ padding: '12px' }}>
          <Message>
            <div>
              <Icon name="quote left" />
              <br />
              <div
                style={{
                  textAlign: 'center',
                  fontSize: '24px',
                  lineHeight: '1.4em',
                }}
              >
                {current && current.jp}
              </div>
              <div style={{ textAlign: 'right' }}>
                <Icon name="quote right" />
              </div>
            </div>
          </Message>
        </div>
        <div
          style={{
            textAlign: 'center',
            marginTop: '24px',
            marginBottom: '24px',
            fontSize: '24px',
          }}
        >
          <a href="#" onClick={() => setShow(!show)}>
            {show ? '答えを閉じる' : '答えを表示'}
          </a>
        </div>
        {show && (
          <div style={{ padding: '12px' }}>
            <Message color="blue">
              <div>
                <Icon name="quote left" />
                <span>
                  <b> タップで音声再生</b>
                </span>
                <br />
                <div
                  style={{
                    textAlign: 'center',
                    fontSize: '24px',
                    lineHeight: '1.4em',
                  }}
                >
                  {current && current.en}
                </div>
                <div style={{ textAlign: 'right' }}>
                  <Icon name="quote right" />
                </div>
              </div>
            </Message>
          </div>
        )}
        {current && (
          <div style={{ textAlign: 'center' }}>
            <Checkbox
              onChange={async () => {
                await update(current.id, current.checked === 1 ? 0 : 1);
                setCurrent({
                  ...current,
                  checked: current && current.checked === 1 ? 0 : 1,
                });
                const result = await fetch();
                setItems(result);
                setCheckedItems(result.filter((v) => v.checked === 1));
              }}
              checked={current && current.checked === 1}
              label={<label style={{ fontSize: '16px' }}>後で確認</label>}
            ></Checkbox>
          </div>
        )}
      </div>
      <div style={{ display: 'flex', marginTop: '50px' }}>
        <div style={{ width: '50%', padding: '10px' }}>
          <CustomButton content="前へ" color="#2185d0" onClick={() => prev()} />
        </div>
        <div style={{ width: '50%', padding: '10px' }}>
          <CustomButton content="次へ" color="#21ba45" onClick={() => next()} />
        </div>
      </div>
      <div style={{ width: '100%', padding: '15px' }}>
        <input
          style={{ width: '100%' }}
          type="range"
          min={1}
          max={isChecked ? checkedItems.length : items.length}
          value={index}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
            const next = Number(e.target.value);
            setCurrent(isChecked ? checkedItems[next - 1] : items[next - 1]);
            setIndex(next - 1);
          }}
        />
      </div>
    </>
  );
};

export default Component;
